/**
 * Imposter. "(3) → Banish an Avatar from your collection to mask
 * yourself. Gain their abilities until damaged or until you put on a
 * new mask."
 *
 * Deckbuilding side: `allowExtraAvatars` lets the player park extra
 * avatars in the spellbook or collection without tripping the singleton
 * "one Avatar per deck" rule.
 *
 * In-game side: the Mask ability is registered here as an
 * `extraActivatedAbilities` entry with the `_builtin: 'imposter_mask'`
 * discriminator. GameBoard's `_activateAbility` dispatches it to the
 * collection-picker flow; resolution swaps the imposter's identity
 * fields (cardId, name, imageUrl, subTypes, elements, printed keywords,
 * Movement+N, Ranged N) to the picked avatar so every downstream rule
 * pipeline. `resolveAvatarRules`, the sidecar automation lookup,
 * `recomputeStaticAuras`, the parser-emitted activated entries. Resolves
 * to the masked avatar automatically. The original identity is snapshot
 * on the instance as `_originalIdentity` and restored when the mask
 * comes off (damage trigger or a fresh mask).
 *
 * `_isImposter: true` is stamped on the instance at spawn so the Mask
 * ability remains visible in the action menu even while masked. The
 * masked avatar's cardId no longer resolves to this rule object.
 */
export const IMPOSTER_RULES = {
  deckbuilding: {
    allowExtraAvatars: true,
  },
  extraActivatedAbilities: [
    {
      id: '__builtin_imposter_mask',
      trigger: 'activated',
      cost: [{ type: 'mana', amount: 3 }],
      description: 'Put on a mask',
      _builtin: 'imposter_mask',
    },
  ],
};
